import { render, staticRenderFns } from "./AddWhiteList.vue?vue&type=template&id=2d202737"
import script from "./AddWhiteList.vue?vue&type=script&lang=js"
export * from "./AddWhiteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports